import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
} from '../../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { ModalTypes } from 'types/global.interface'
import { clearBreakPolicies, deleteBreakPolicy, getBreakPolicies } from 'features/breaks/breaksSlice'
import { useNavigate } from 'react-router-dom'

export const BreakPolicies: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { data, totalPages } = useSelector((state: RootState) => state.breaks.breakPolicies)
    const navigate = useNavigate()

    useQueryPagination({ fetchFunctions: [getBreakPolicies], cleanUpFunctions: [clearBreakPolicies], params })

    const handleRemove = (id: string) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteBreakPolicy(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: data.length < 2,
                },
                word: 'delete policy',
            }),
        )
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Policies' />
                    <Button orange onClick={() => navigate('add')} >
                        Add Policy
                    </Button>
                </Flex>
                {!data?.length ? (
                    <NoItems title='Policies' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='15%' noTooltip text='BREAK TEMPLATE' />
                            <Td w='15%' noTooltip text='MAX ON BREAK' />
                            <Td w='15%' noTooltip text='MINIMUM ACTIVE' />
                            <Td w='20%' noTooltip text='MINIMUM GAP BETWEEN BREAKS' />
                            <Td w='15%' noTooltip text='VALID FROM' />
                            <Td w='15%' noTooltip text='VALID TO' />
                            <Td w='5%' />
                        </Th>
                        {data.map((item) => (
                            <Tr key={item.id}>
                                <Td w='15%' text={item.breakTemplate?.name || '/'} />
                                <Td w='15%' text={item.maxOnBreak || '/'} />
                                <Td w='15%' text={item.minActive || '/'} />
                                <Td w='20%' text={item.minGapBetweenBreaksInMinutes || '/'} />
                                <Td w='15%' text={item.validFromDate ? formatDateForDisplay(item.validFromDate) : '/'} />
                                <Td w='15%' text={item.validToDate ? formatDateForDisplay(item.validToDate) : '/'} />
                                <Td options w='5%'>
                                    <Options item={item} title='Break Policies' handleRemove={handleRemove} />
                                </Td>
                            </Tr>
                        ))}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
